import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { RdsIconsModule, RdsSidenavModule } from '@rds/angular-components';

import { FeatureFlagDirective } from '../../../directives/feature-flag.directive';

@Component({
  selector: 'inexp-focus-sidebar',
  imports: [RdsIconsModule, RouterModule, RdsSidenavModule, FeatureFlagDirective],
  templateUrl: './focus-sidebar.component.html',
  styleUrl: './focus-sidebar.component.scss',
})
export class FocusSidebarComponent {}
